import React from 'react';

import DesktopDialog from '@/components/common/desktopDialog';
import MobileDrawer from '@/components/common/mobileDrawer';
import { useSelector } from 'react-redux';
import { selectIsMobile } from '@/store/modules/userDataSlice';

interface IProps {
    show: boolean;
    title?: string;
    onClose?: () => void;
    isMobile?: boolean;
    hideClose?: boolean;
    className?: string;
    children: React.ReactElement | React.ReactElement[];
}

const MobileOrDesktopDialog: React.FC<IProps> = ({
    isMobile,
    children,
    ...rest
}) => {
    const isMob = useSelector(selectIsMobile);
    return isMob ? (
        <MobileDrawer {...rest}>{children}</MobileDrawer>
    ) : (
        <DesktopDialog {...rest}>{children}</DesktopDialog>
    );
};

export default MobileOrDesktopDialog;
